import vm from '../main'

const internals = {}

internals.addtripRoute = function(tripRoute) {
    tripRoute = (({
        _id,
        name,
        approxDistance,
        approxTime,
        status,
        startSite,
        endSite,
        routeMarkers,
        region,
        reportAssessment
    }) => {
        return {
            _id,
            name,
            approxDistance,
            approxTime,
            status,
            startSite,
            endSite,
            routeMarkers,
            region,
            reportAssessment
        }
    })(tripRoute)

    return vm.$triprouteDataRepository
        .create(tripRoute)
        .then(result => {
            tripRoute = result.data
            return tripRoute
        })
        .catch(error => {
            console.error('tripRouteService.createtripRoute-error:\n', error)
            throw error
        })
}

internals.updatetripRoute = function(tripRoute) {
    tripRoute = Object.assign({}, tripRoute)
    tripRoute = (({
        _id,
        name,
        approxDistance,
        approxTime,
        status,
        startSite,
        endSite,
        routeMarkers,
        region,
        reportAssessment
    }) => {
        return {
            _id,
            name,
            approxDistance,
            approxTime,
            status,
            startSite,
            endSite,
            routeMarkers,
            region,
            reportAssessment
        }
    })(tripRoute)
    return vm.$triprouteDataRepository
        .update(tripRoute._id, tripRoute)
        .then(result => {
            tripRoute = result.data
            return tripRoute
        })
        .catch(error => {
            console.error('tripRouteUpdate.update-error:\n', error)
            throw error
        })
}

export default internals


// WEBPACK FOOTER //
// ./src/services/tripRoute.service.js